<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { ModelListSelect } from "vue-search-select";
import { mapGetters, mapActions, mapState } from "vuex";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Package Services",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    ModelListSelect,
  },
  data() {
    return {
      title: "Insurance Package Services",
      id: atob(this.$route.params.id),
      name: atob(this.$route.params.name),
      lock: true,
      items: [
        {
          text: "Home",
          href: "#/",
        },
        {
          text: "Package Services",
          active: true,
        },
      ],
      totalRows: 1,

      currentPage: 1,
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      modal_id: "",
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "name",
          sortable: true,
          label: "SERVICE NAME",
        },
        {
          key: "cost_field",
          sortable: true,
          label: "COST",
        },
        {
          sortable: false,
          key: "actions",
          label: "ACTIONS",
        },
      ],

      services: [],
      data: {
        department: "",
      },
      chkAll: {
        package: atob(this.$route.params.id),
      },
    };
  },
  computed: {
    // MAP STATE
    ...mapState("notification", [
      "notificationtype",
      "notification_message",
      "notification_show",
    ]),
    ...mapGetters("insurance", ["PackageServices", "InsuranceStatus"]),
    ...mapState("insurance", ["package_services"]),
    ...mapGetters("services", ["ReportFiltersDepartments"]),
    ...mapGetters("auth", ["user_permissions"]),
  },
  mounted() {
    // Set the initial number of items
    // this.totalRows = this.services ? this.services.length : 1;
  },
  watch: {
    notification_show(newValue) {
      // Do whatever makes sense now
      if (newValue == true) {
        if (this.notificationtype == "success") {
          this.$toast.success(this.notification_message.msg);
        } else {
          this.$toast.error(this.notification_message.msg);
        }
      }
    },
    package_services(newValue) {
      if (newValue.length > 0) {
        this.assiginData();
      }
    },
  },
  methods: {
    ...mapActions({
      FetchPackageServices: "insurance/fetchPackageServices",
      ChangeStatus: "insurance/changeServiceStatus",
      CheckAll: "insurance/changeServiceStatusAll",
      ChangePrice: "insurance/changeServicePrice",
    }),

    // COMMA SEPERATORS
    thousandSeperator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
          .toString()
          .replace(/\D/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    assiginData() {
      this.services = this.PackageServices;
    },
    filterServices() {
      if (this.data.department != 0) {
        this.services = this.PackageServices.filter((element) => {
          return element.service_type == this.data.department;
        });
      } else {
        this.services = this.PackageServices;
      }
    },
    toggleLock() {
      this.lock = !this.lock;
    },
    checkAll() {
      this.CheckAll(this.chkAll);
    },
    putCommas(value) {
      value.serv_price = this.thousandSeperator(value.serv_price);
    },
    changep(value) {
      this.ChangePrice(value);
    },
    updateStatus(data) {
      this.ChangeStatus(data);
    },
  },
  created() {
    this.FetchPackageServices(this.id);
  },
};
</script>

<template>
  <Layout>
    <Toasts
      :show-progress="true"
      :rtl="true"
      :max-messages="20"
      :time-out="3000"
      :closeable="false"
      :solid="true"
    ></Toasts>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-12">
                <h2>Insurance Services Under {{ this.name }}</h2>
                <div v-if="user_permissions.edit_insurance_company_package_services">
                  <b-button @click="$router.go(-1)" class="float-left" variant="warning"
                    ><i class="fa fa-arrow-left"></i> Go Back</b-button
                  >
                  <b-button
                    v-if="lock"
                    @click="toggleLock()"
                    class="float-end"
                    variant="primary"
                    ><i class="fa fa-lock"></i> Unlock Services</b-button
                  >
                  <b-button
                    v-else
                    @click="toggleLock()"
                    class="float-end"
                    variant="primary"
                    ><i class="fa fa-lock"></i> Lock Services</b-button
                  >
                </div>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-4 mb-2">
                <div class="form-group">
                  <label class="col-form-label" for="userName">Filter Departments</label>
                  <model-list-select
                    @input="filterServices()"
                    :list="ReportFiltersDepartments"
                    v-model="data.department"
                    option-value="id"
                    option-text="name"
                    placeholder="Select Department"
                  >
                  </model-list-select>
                </div>
              </div>
              <div class="col-4"></div>
              <!-- Search -->
              <div class="col-4">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end mt-4">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
              <!-- <div v-if="!lock">
                <div class="form-group float-end">
                  <span class="text-primary font-size-18">Check All</span
                  ><input type="checkbox" @input="checkAll()" class="customx" />
                </div>
              </div> -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                class="datatables"
                :items="services ? services : []"
                :fields="fields"
                responsive="sm"
                :current-page="currentPage"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(cost_field)="data">
                  <input
                    v-if="!lock"
                    :key="data.index"
                    type="text"
                    class="custom"
                    @input="putCommas(data.item)"
                    @blur="changep(data.item)"
                    v-model="data.item.serv_price"
                  />
                  <span v-else>{{ data.item.serv_price }}</span>
                </template>
                <template #cell(actions)="data">
                  <input
                    :key="data.index"
                    v-if="data.item.status == 1 && !lock"
                    type="checkbox"
                    @input="updateStatus(data.item)"
                    checked
                    class="custom"
                  />
                  <input
                    :key="data.index"
                    v-if="data.item.status == 1 && lock"
                    type="checkbox"
                    @input="updateStatus(data.item)"
                    checked
                    disabled
                    class="custom"
                  />
                  <input
                    :key="data.index"
                    v-if="data.item.status != 1 && lock"
                    type="checkbox"
                    @input="updateStatus(data.item)"
                    disabled
                    class="custom"
                  />
                  <input
                    :key="data.index"
                    v-if="data.item.status != 1 && !lock"
                    type="checkbox"
                    @input="updateStatus(data.item)"
                    class="custom"
                  />
                </template>
              </b-table>
              <center>
                <h3 v-if="!services" class="text-primary">
                  <b-spinner class="m-0" variant="primary" role="status"></b-spinner>
                  Please wait...
                </h3>
              </center>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.custom {
  width: 80px;
  height: 30px;
  margin-right: 2px;
  box-sizing: border-box;
  padding: 12px 5px;
}
.customx {
  width: 35px;
  height: 30px;
  margin-right: 2px;
  box-sizing: border-box;
  padding: 12px 5px;
}
.bt {
  margin-right: 120px;
  margin-top: 40px;
}
</style>
